import { useState } from 'react';
import { Input, Label } from 'reactstrap';
import Lightbox from '../../../components/Common/Lightbox';
import policy from './documents/Ofca.Policy.pdf';
import terms from './documents/Ofca.TermsOfUse.pdf';
import { Link } from 'react-router-dom';

export interface IOfcaTermsAndPolicy {
	termsAgreed: boolean;
	setTermsAgreed: (termsAgreed: boolean) => void;
}

export const OfcaTermsAndPolicy = (props: IOfcaTermsAndPolicy) => {
	const { termsAgreed, setTermsAgreed } = props;

	var termsOfUse = (
		<Link
			to='#'
			onClick={() => window.open(terms, '_blank')}
		>
			Terms of Use
		</Link>
	);
	var privacyPolicy = (
		<Link
			to='#'
			onClick={() => window.open(policy, '_blank')}
		>
			Privacy Policy
		</Link>
	);

	const handleChange = () => {
		setTermsAgreed(!termsAgreed);
	};

	return (
		<div className='custom-control custom-checkbox mb-3'>
			<Input
				type='checkbox'
				id='ofca-terms'
				className='custom-control-input'
				name='ofcaTermsAndConditions'
				checked={termsAgreed}
				onChange={handleChange}
			/>
			<Label
				className='custom-control-label'
				htmlFor='ofca-terms'
			>
				I agree to the {termsOfUse} and {privacyPolicy}.
			</Label>
		</div>
	);
};
